import { render, staticRenderFns } from "./cart-contact-info.vue?vue&type=template&id=2b2eac0b&lang=pug&"
import script from "./cart-contact-info.vue?vue&type=script&lang=js&"
export * from "./cart-contact-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports